import React from 'react';
import { Outlet } from 'react-router-dom';
// import RouteProgress from '../RouteProgress'; // Removed due to performance issues

const RootLayout: React.FC = () => {
  return (
    <>
      {/* <RouteProgress /> - Removed due to performance issues */}
      <Outlet />
    </>
  );
};

export default RootLayout;

